// Mock data for Marhaban Tour & Travel Landing Page

export const companyInfo = {
  name: "Marhaban Tour & Travel",
  tagline: "Wujudkan Impian Ibadah Umroh Anda",
  phone: "0822 2108 5480",
  contactPerson: "Ust. Muadz",
  address: "Marhaban Tour, Simo, Boyolali",
  email: "marhabanindotravel@gmail.com",
  whatsapp: "6282221085480",
  cs_whatsapp: "6285385451686"
};

export const heroContent = {
  title: "Umroh Plus Mesir",
  subtitle: "Awal Ramadhan 2026 M / 1447 H",
  description: "Temukan hikmah dari Mesir ke Mekkah, siapkan Ramadhan dengan hati bersih",
  price: "29,5 Jt",
  priceLabel: "All-in hanya",
  departureDate: "18 Februari 2026",
  heroImage: "https://images.unsplash.com/photo-1720549973451-018d3623b55a"
};

export const packages = [
  {
    id: 1,
    name: "Umroh Plus Mesir",
    subtitle: "Awal Ramadhan 2026",
    price: "29.5 Jt",
    duration: "14 Hari",
    departure: "18 Februari 2026",
    image: "https://images.unsplash.com/photo-1600520611035-84157ad4084d",
    airline: "EgyptAir",
    route: "Cairo - Madinah - Makkah",
    featured: true,
    highlights: [
      "City Tour Cairo",
      "Pyramids & Museum",
      "Nile Cruise Dinner",
      "Umroh 2x",
      "Hotel Bintang 4-5",
      "Makan Sahur & Berbuka"
    ],
    hotels: {
      cairo: "Cairo (1 Malam) - Tyba Pyramid / Setaraf TS",
      madinah: "Madinah (3 Malam) - ODST/Daar Al Naem/Setaraf",
      makkah: "Makkah (3 Malam) - Saja Hotel/Le Meridien Tower/Setaraf"
    }
  },
  {
    id: 2,
    name: "Umroh Ramadhan Premium",
    subtitle: "Paket Ramadhan 2026",
    price: "25 Jt",
    duration: "10 Hari",
    departure: "25 Februari 2026",
    image: "https://images.unsplash.com/photo-1710695198971-3abdf7fcc82e",
    airline: "Saudia Airlines",
    route: "Madinah - Makkah",
    featured: false,
    highlights: [
      "Umroh di Bulan Ramadhan",
      "Hotel Dekat Masjid",
      "Makan 3x Sehari",
      "Tour Leader Berpengalaman",
      "Visa & Perlengkapan",
      "City Tour Lengkap"
    ]
  },
  {
    id: 3,
    name: "Umroh Reguler",
    subtitle: "Berangkat Setiap Bulan",
    price: "22 Jt",
    duration: "9 Hari",
    departure: "Fleksibel",
    image: "https://images.unsplash.com/photo-1572358899655-f63ece97bfa5",
    airline: "Garuda / Saudia",
    route: "Madinah - Makkah",
    featured: false,
    highlights: [
      "Jadwal Fleksibel",
      "Hotel Strategis",
      "Makan 3x Sehari",
      "Bimbingan Ibadah",
      "Perlengkapan Lengkap",
      "Manasik Umroh"
    ]
  }
];

export const facilities = [
  {
    icon: "Plane",
    title: "Penerbangan Berkualitas",
    description: "EgyptAir, Saudia, atau Garuda Indonesia"
  },
  {
    icon: "Hotel",
    title: "Hotel Bintang 4-5",
    description: "Lokasi strategis dekat Masjidil Haram & Nabawi"
  },
  {
    icon: "Utensils",
    title: "Makan 3x Sehari",
    description: "Menu Indonesia, Arabian Food, dan spesial Ramadhan"
  },
  {
    icon: "Bus",
    title: "Bus Exclusive AC",
    description: "Transportasi nyaman selama perjalanan"
  },
  {
    icon: "MapPin",
    title: "City Tour Lengkap",
    description: "Cairo, Madinah, Makkah dengan guide profesional"
  },
  {
    icon: "Users",
    title: "Tour Leader Berpengalaman",
    description: "Pendampingan & bimbingan ibadah"
  },
  {
    icon: "FileText",
    title: "Visa & Dokumen",
    description: "Pengurusan visa Umroh dan Cairo"
  },
  {
    icon: "Briefcase",
    title: "Perlengkapan Lengkap",
    description: "Koper, Air Zam-Zam 5L, dll"
  }
];

export const tourPrograms = [
  {
    day: "Hari 1-2",
    location: "Cairo, Mesir",
    activities: [
      "City Tour Cairo",
      "Kunjungan Piramida & Sphinx",
      "Museum Mummy",
      "Dinner Nile Cruise"
    ]
  },
  {
    day: "Hari 3-5",
    location: "Madinah",
    activities: [
      "Ziarah Masjid Nabawi",
      "Raudhah & Makam Rasulullah",
      "Masjid Quba",
      "Jabal Uhud",
      "City Tour Madinah"
    ]
  },
  {
    day: "Hari 6-12",
    location: "Makkah",
    activities: [
      "Umroh 2x",
      "Thawaf & Sa'i",
      "Jabal Rahmah",
      "Gua Hira",
      "Masjid Jin",
      "City Tour Makkah"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ibu Siti Aminah",
    location: "Semarang",
    package: "Umroh Plus Mesir 2025",
    rating: 5,
    comment: "Alhamdulillah, perjalanan yang sangat berkesan! Pelayanan Marhaban Tour sangat memuaskan. Tour leader sangat membantu dan sabar membimbing kami. Hotelnya nyaman dan dekat dengan masjid.",
    image: "https://images.unsplash.com/photo-1766858734458-e80bf236563f",
    date: "Januari 2025"
  },
  {
    id: 2,
    name: "Bapak Ahmad Rizki",
    location: "Solo",
    package: "Umroh Ramadhan 2025",
    rating: 5,
    comment: "Pengalaman umroh di bulan Ramadhan sangat luar biasa! Fasilitas lengkap, makanan enak, dan bimbingan ibadah yang baik. Terima kasih Marhaban Tour sudah memfasilitasi ibadah kami.",
    image: "https://images.pexels.com/photos/7984586/pexels-photo-7984586.jpeg",
    date: "Maret 2025"
  },
  {
    id: 3,
    name: "Ibu Fatimah Zahra",
    location: "Yogyakarta",
    package: "Umroh Plus Mesir 2024",
    rating: 5,
    comment: "Perjalanan ke Mesir dan Mekkah sangat terorganisir dengan baik. Piramida, Museum, dan Nile Cruise di Cairo benar-benar menambah wawasan. Umrohnya juga sangat khusyuk. Recommended!",
    image: "https://images.unsplash.com/photo-1742021923154-3f6efc436a0f",
    date: "November 2024"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1720549973451-018d3623b55a",
    caption: "Masjidil Haram, Makkah",
    category: "makkah"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1600520611035-84157ad4084d",
    caption: "Piramida Giza, Cairo",
    category: "cairo"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1572358899655-f63ece97bfa5",
    caption: "Masjid Nabawi, Madinah",
    category: "madinah"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1568322445389-f64ac2515020",
    caption: "Sphinx & Piramida",
    category: "cairo"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1710695198971-3abdf7fcc82e",
    caption: "Ka'bah dari Dekat",
    category: "makkah"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1737807478491-6e258b44bd04",
    caption: "Interior Hotel Premium",
    category: "hotel"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1742021923154-3f6efc436a0f",
    caption: "Madinah Saat Maghrib",
    category: "madinah"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1723465302725-ff46b3e165f9",
    caption: "Lobby Hotel Mewah",
    category: "hotel"
  }
];

export const whyChooseUs = [
  {
    title: "Berpengalaman",
    description: "Lebih dari 10 tahun melayani jamaah umroh ke tanah suci",
    icon: "Award"
  },
  {
    title: "Terpercaya",
    description: "Terdaftar resmi dan berizin dari Kementerian Agama",
    icon: "ShieldCheck"
  },
  {
    title: "Pelayanan Terbaik",
    description: "Tim profesional siap membantu 24/7 selama perjalanan",
    icon: "HeartHandshake"
  },
  {
    title: "Harga Transparan",
    description: "Tidak ada biaya tersembunyi, semua all-inclusive",
    icon: "BadgeCheck"
  }
];

export const faqs = [
  {
    question: "Apa saja yang sudah termasuk dalam paket?",
    answer: "Paket sudah termasuk: tiket pesawat PP, hotel, makan 3x sehari, transportasi, visa, perlengkapan, bimbingan ibadah, tour leader, dan city tour sesuai program."
  },
  {
    question: "Bagaimana cara pembayaran?",
    answer: "Pembayaran bisa dilakukan dengan cara: DP minimal 10 juta, cicilan hingga 3x, atau lunas. Kami juga melayani pembayaran via transfer bank atau cash."
  },
  {
    question: "Apakah ada pendampingan selama di tanah suci?",
    answer: "Ya, setiap rombongan didampingi oleh tour leader dan muthawif berpengalaman yang akan membimbing ibadah dan membantu segala kebutuhan jamaah."
  },
  {
    question: "Bagaimana jika saya belum punya paspor?",
    answer: "Kami akan membantu proses pengurusan paspor. Tim kami siap memberikan panduan lengkap dan membantu persiapan dokumen yang diperlukan."
  },
  {
    question: "Apakah ada batasan usia untuk ikut umroh?",
    answer: "Untuk umroh, minimal usia 12 tahun. Untuk jamaah lansia, kami sarankan konsultasi terlebih dahulu untuk memastikan kondisi kesehatan mendukung perjalanan."
  }
];
